export default class TopologyVector {
    _geometryOffsets;
    _partOffsets;
    _ringOffsets;
    //TODO: refactor to use unsigned integers
    constructor(_geometryOffsets, _partOffsets, _ringOffsets) {
        this._geometryOffsets = _geometryOffsets;
        this._partOffsets = _partOffsets;
        this._ringOffsets = _ringOffsets;
    }
    get geometryOffsets() {
        return this._geometryOffsets;
    }
    get partOffsets() {
        return this._partOffsets;
    }
    get ringOffsets() {
        return this._ringOffsets;
    }
}
//# sourceMappingURL=topologyVector.js.map